import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Button,
  Box,
  styled,
} from "@mui/material";
import RegisterForm from "../register/DemoForm";
import SelectPlan from "../plans-and-services/select-plan";
import imgBanner from "../../assets/banner-playground.png";
import { useLocation } from "react-router-dom";

const BannerImage = styled("img")({
  cursor: "pointer",
  margin: "0 0 0 0",
  width: "100%",
  maxWidth: "100%",
  height: "auto",
  display: "block",
});

function BannerWithModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  let { state } = useLocation();

  const defaultPlan = {
    creation_date: "",
    payment_date: "",
    start_date: "",
    end_date: "",
    time_plan: 1,
    status: "",
    plan_value: 1090,
    total_user: 1,
    is_demo: "",
    features: [
      {
        feature_id: 5,
        name: "Usuario",
        name_english: "User",
        quantity: 1,
        unite_price: 1090,
      },
    ],
  };

  const plan = (state && state.plan) || defaultPlan;

  return (
    <>
      {/* Banner como imagen */}
      <Box onClick={handleOpen}>
        <BannerImage src={imgBanner} alt="Banner promocional" />
      </Box>
      <Dialog
        open={isModalOpen}
        onClose={handleClose}
        maxWidth={false}
        fullWidth={false}
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "visible",
            width: "80%",
            maxWidth: "1300px",
            height: "90%",
          },
        }}
      >
        {/* Pestañas centradas */}
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="secondary"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#3f008e",
              },
              "& .MuiTab-root": {
                color: "#3f008e",
                fontWeight: "bold",
              },
              "& .Mui-selected": {
                color: "#3f008e",
                fontWeight: "bold",
              },
              "& .MuiTabs-flexContainer": {
                borderBottom: "none",
              },
            }}
          >
            <Tab label="Solicitar un Demo" />
            <Tab label="Comprar una Suscripción" />
          </Tabs>
        </Box>

        <DialogContent>
          {/* Contenido de las pestañas */}
          <Box sx={{ pt: 2 }}>
            {activeTab === 0 && <RegisterForm />}
            {activeTab === 1 && (
              <SelectPlan planHome={plan} breakpoint={"xs"} />
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default BannerWithModal;
